export function PersonIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15 7.5C15 5.383 13.482 4 12 4S9 5.383 9 7.5c0 .852.43 1.745 1.16 2.472C10.937 10.743 11.71 11 12 11c.291 0 1.064-.257 1.84-1.028C14.57 9.245 15 8.352 15 7.5zm2 0c0 3.038-3 5.5-5 5.5s-5-2.462-5-5.5S9.239 2 12 2s5 2.462 5 5.5zM10.582 16a3.99 3.99 0 00-3.894 3.124L6.493 20h11.014l-.107-.482A4.493 4.493 0 0013.014 16h-2.432zm-4.873.508A5.99 5.99 0 0110.582 14h2.431a6.493 6.493 0 016.34 5.085l.263 1.187A1.42 1.42 0 0118.23 22H5.999a1.603 1.603 0 01-1.565-1.951l.302-1.359a5.988 5.988 0 01.973-2.182z"
      ></path>
    </svg>
  );
}
